import React, { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const LegalEntityTypeStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const LegalEntityTypeContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <LegalEntityTypeStateContext.Provider value={stateHook}>
      {children}
    </LegalEntityTypeStateContext.Provider>
  );
};

export default LegalEntityTypeContextProvider;